<template>
  <div>
    <p v-if="displayType === 'long'">
      Unclassified positions include non-publicly listed securities such as private asset classes.
      Alternatives refer to publicly traded non-traditional assets such as commodities, digital currency trusts, derivatives, and structured notes.
      Geographic classification is based on the country of domicile of the company.
      Asset allocation data from funds uses holdings as of data of most recent NPORT SEC filing.
      Allocation percentages for funds are calculated using the fund's net assets (total assets minus liabilities).
    </p>

    <p v-else>
      Unclassified positions include non-publicly listed securities such as private asset classes.
      Alternatives refer to publicly traded non-traditional assets such as commodities, digital currency trusts, derivatives, and structured notes.
      Geographic classification is based on the country of domicile of the company.
      Asset allocation data from funds uses holdings as of data of most recent NPORT SEC filing.
      Allocation percentages for funds are calculated using the fund's net assets (total assets minus liabilities).
    </p>
  </div>
</template>


<script>
export default {
  name: 'AssetClassMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
};
</script>
